import {
    SET_IS_LOADING,
    SET_IS_READ_ONLY,
    EDIT_PROBLEM,
    DELETE_PROBLEM,
    ADD_PROBLEM,
    GET_PATIENT_VISIT,
    SET_WINDOW_PROPS,
    TOGGLE_IS_VALID_PLAN,
    SET_PROBLEM_EDIT,
    SET_SHOW_PROBLEM_FORM,
    UPDATE_PATIENT_VISIT_DATA,
} from '../types';

import {CARE_PLAN_STATUS_ENUM} from './constants';

export default (state, action) => {
    switch (action.type) {
        case UPDATE_PATIENT_VISIT_DATA:
            return {
                ...state,
                patientVisitData: action.payload,
            };
        case GET_PATIENT_VISIT:
            return {
                ...state,
                carePlanMetadata: action.payload.meta,
                isEditable:
                    action.payload.data.care_plan_status ===
                    CARE_PLAN_STATUS_ENUM.OPEN,
                isLoading: false,
                patientVisitData: action.payload.data,
                status: action.payload.data.care_plan_status,
            };
        case DELETE_PROBLEM:
            return {
                ...state,
                isLoading: false,
                patientVisitData: {
                    ...state.patientVisitData,
                    problem_set: action.payload,
                },
                showProblemForm: false,
            };
        case ADD_PROBLEM:
            return {
                ...state,
                isLoading: false,
                patientVisitData: {
                    ...state.patientVisitData,
                    problem_set: [
                        ...state.patientVisitData.problem_set,
                        action.payload,
                    ],
                },
                showProblemForm: false,
            };
        case EDIT_PROBLEM:
            return {
                ...state,
                isLoading: false,
                problemToEdit: null,
                showProblemForm: false,
            };
        case SET_WINDOW_PROPS:
            const {
                patientVisitId,
                patientVisitType,
                patientVisitUsername,
                csrfToken,
                problems,
                deficits,
                diagnoses,
                risk,
                user,
                providers,
                medicationOptions,
                medications,
            } = action.payload;
            return {
                ...state,
                csrfToken: csrfToken,
                currentMedicationsWindowArray: medications,
                deficitsWindowArray: deficits,
                diagnosesWindowArray: diagnoses,
                medicationWindowArray: medicationOptions,
                patientVisitId: patientVisitId,
                patientVisitType: patientVisitType,
                patientVisitUsername: patientVisitUsername,
                problemsWindowArray: problems,
                providers: providers,
                risk: risk,
                user: user,
            };
        case TOGGLE_IS_VALID_PLAN:
            return {
                ...state,
                isValidPlan: action.payload,
            };
        case SET_IS_LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case SET_IS_READ_ONLY:
            return {
                ...state,
                isReadOnly: action.payload,
            };
        case SET_SHOW_PROBLEM_FORM:
            return {
                ...state,
                isLoading: false,
                problemToEdit: null,
                showProblemForm: action.payload,
            };
        case SET_PROBLEM_EDIT:
            return {
                ...state,
                isLoading: false,
                problemToEdit: action.payload,
            };
        default:
            return state;
    }
};
